/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_H_ProgInputs */

const en_cp_cmp_h_prog = /** @type {(inputs: Cp_Cmp_H_ProgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program`)
};

const id_cp_cmp_h_prog = /** @type {(inputs: Cp_Cmp_H_ProgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program`)
};

/**
* | output |
* | --- |
* | "Program" |
*
* @param {Cp_Cmp_H_ProgInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_h_prog = /** @type {((inputs?: Cp_Cmp_H_ProgInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_H_ProgInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_h_prog(inputs)
	return en_cp_cmp_h_prog(inputs)
});